<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_iv"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copyright">© 2008 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Newman, Richard S.<br/>Freedom’s prophet : Bishop Richard Allen, the AME Church,<br/>and the Black founding fathers / Richard S. Newman.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8147-5826-7 (cl : alk. paper)<br/>ISBN-10: 0-8147-5826-6 (cl : alk. paper)<br/>1. Allen, Richard, 1760–1831. 2. African Methodist Episcopal<br/>Church—Bishops—Biography. 3. Bishops—United States—<br/>Biography. 4. African Methodist Episcopal Church—History.<br/>I. Title.<br/>BX8459.A4N49 2008<br/>287'.83—dc22       2007043259<br/>[B]</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America<br/>10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?260cd04a